import { useState } from "react";
import { Loader2, LogIn, Receipt } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Checkbox } from "../components/ui/checkbox";
import { api, errMsg } from "../lib/api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { onLogin(await api.login(email, password, remember)); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4" data-testid="login-page">
      <form onSubmit={submit} className="grid w-full max-w-sm gap-5 rounded-2xl border border-slate-200 bg-white p-7 shadow-sm fade-up" data-testid="login-form">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-900 text-white"><Receipt className="h-5 w-5" /></div>
          <div className="font-display text-xl font-bold tracking-tight text-slate-900">BelegFinder</div>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Anmelden</h1>
        <div className="grid gap-1.5">
          <Label htmlFor="email" className="text-sm font-semibold text-slate-700">E-Mail</Label>
          <Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="login-email-input" />
        </div>
        <div className="grid gap-1.5">
          <Label htmlFor="password" className="text-sm font-semibold text-slate-700">Passwort</Label>
          <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11" data-testid="login-password-input" />
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-700">
          <Checkbox checked={remember} onCheckedChange={(v) => setRemember(!!v)} data-testid="login-remember-checkbox" />Angemeldet bleiben (30 Tage)
        </label>
        {error && <p className="rounded-lg bg-red-50 p-3 text-sm text-red-800" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-11 gap-1.5 bg-slate-900 hover:bg-slate-800" data-testid="login-submit-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}Anmelden
        </Button>
      </form>
    </div>
  );
}
